
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ApolloProvider } from "@apollo/client";
import client from "./utils/apolloClient";
import "./error/globalErrorHandler";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// 🔹 REMOVE INITIAL HTML LOADER (ADDED)
const loader = document.getElementById("please-wait");
if (loader) loader.remove();

const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

root.render(
  <ThemeProvider theme={theme}>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </ThemeProvider>
);
